import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './base/app'
import appConfig from './base/app-config'
import verticalMenu from './base/vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
})
